export default () => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 23 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 6.875H22"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M3.625 6.875H19.375V22.625C19.375 23.0891 19.1905 23.5343 18.8624 23.8624C18.5343 24.1905 18.0891 24.375 17.625 24.375H5.375C4.91087 24.375 4.46575 24.1905 4.13756 23.8624C3.80938 23.5343 3.625 23.0891 3.625 22.625V6.875Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M7.125 6.875V6C7.125 4.83968 7.58593 3.72687 8.4064 2.9064C9.22687 2.08594 10.3397 1.625 11.5 1.625C12.6603 1.625 13.7731 2.08594 14.5936 2.9064C15.4141 3.72687 15.875 4.83968 15.875 6V6.875"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8.875 12.1274V19.1301"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M14.125 12.1274V19.1301"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
